// Print analyses routes
export default [
  {
    path: 'print-analyses',
    name: 'printAnalyses',
    component: () =>
      import(
        /* webpackChunkName: "printAnalyses" */ '../views/printAnalyses/PrintAnalyses.vue'
      ),
    meta: {
      tabbable: true,
      tableKeys: [],
      filterKeys: [],
      formKeys: ['printAnalyses'],
      routePermissions: ['printAnalysesManage'],
    },
  },
];
